import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-privacystatement',
  templateUrl: '../../../assets/html/privacystatement.html',
  styleUrls: ['./privacystatement.component.css']
})
export class PrivacystatementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});

  }

}
